<template>
    <div class="fixed master-layout">
        <div class="overflow-y-scroll" style="height: 100vh;">
            <Header :isShow="isShow" />

            <main>
                <div class="content container px-3 " >
                    <slot />
                </div>
            </main>

            <Footer/>

            <FloatingAudioPlayer
                :id="audioId"
                :title="audioTitle"
                :image="audioImage"
                :link_url="audioUrl"
            />
        </div>
    </div>
</template>

<script setup>
import Header from "../Components/Share/Header.vue";
import Footer from "../Components/Share/Footer.vue";
import FloatingAudioPlayer from "../Components/FloatingAudioPlayer.vue";
import { reactive, watch, ref, toRefs, provide } from "vue";


// Global audio state
const audioId = ref(0);
const audioUrl = ref('');
const audioImage = ref('');
const audioTitle = ref('');

provide('setAudioSource', (id, title, image, link_url) => {
  audioId.value = id;
  audioTitle.value = title;
  audioImage.value = image;
  audioUrl.value = link_url;
});

const props = defineProps({
  isShow: Boolean,
});


</script>

